"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workForm = void 0;
const enums_1 = require("@bemlo/enums");
exports.workForm = {
    [enums_1.WorkForm.ENTREPRENEUR]: 'Underkonsult via eget bolag',
    [enums_1.WorkForm.HOURLY_WORKER]: 'Timanställd',
    [enums_1.WorkForm.OPEN_TO_BOTH]: 'Underkonsult eller timanställd',
};
